<template>

    <div class="avatar">
		<div v-bind="$attrs" :class="[disabled ? 'opacity-25' : '']">
			<img :src="this.icon.url" />
		</div>
	</div>

</template>

<script lang="ts">

import { FileIcon } from "@/models/Icon.model";

export default {
    inheritAttrs: false,

    props: {
        icon: {
            type: FileIcon,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
    }
}
</script>